import { configureStore } from '@reduxjs/toolkit';
import loginReducer from 'pages/login/redux/slice';
import tasksReducer from 'pages/Tasks/redux/slice';
import plansReducer from 'pages/EmployeeTasks/redux/slice';
import reviewsReducer from 'pages/AllEmployeeTasks/redux/slice';
import followUpReducer from 'pages/FollowUp/redux/slice';
import configureSlice from 'pages/Configure/redux/slice';
import staffingReducer from 'pages/PlanStaffing/redux/slice';
import projectReducer from 'pages/Staffing/redux/slice';
import notificationReducer from '@/common/Layout/redux/slice';
import socketMiddleware from '@/common/Layout/redux/socketMiddleware';
import weeklyPlanReducer from 'pages/WeeklyList/redux/slice';

export const store = configureStore({
  reducer: {
    login: loginReducer,
    tasks: tasksReducer,
    plans: plansReducer,
    followUp: followUpReducer,
    reviews: reviewsReducer,
    staffing: staffingReducer,
    projectStaffing: projectReducer,
    weeklyPlans: weeklyPlanReducer,
    configure: configureSlice,
    notification: notificationReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(socketMiddleware)
});
